module.exports = __webpack_public_path__ + "static/media/functional-pl.8988a9c9.svg";